import Vue from 'vue';
import VueRouter from 'vue-router';

import LegalRoutes from '../views/LegalDocs/router';
import SignupRoutes from '../domains/Auth/router';

import Authenticating from '../views/Authenticating';
import SignInView from '../domains/Auth/views/SignIn/SignInView';

Vue.use(VueRouter);

// eslint-disable-next-line
export const router = (templateRouter) => new VueRouter({
  mode: 'history',
  base: /^\/__/.test(window.location.pathname) ? `${__dirname}__` : __dirname,
  linkActiveClass: 'Navbar__menuItemLink--active',
  routes: [
    {
      mode: 'abstract',
      path: '/callback',
      alias: '/authenticating',
      component: Authenticating,
    },
    ...LegalRoutes,
    ...templateRouter,
    {
      path: '/signin',
      component: SignInView,
    },
    ...SignupRoutes,
  ],
});
